import { Box, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { useState } from 'react'
import Mobile from '../../assets/svg/Mobile'
import Footer from '../../comps/Footer'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { openPlayStore } from '../../comps/ProductsMegaMenu'
import { jiobizzUpiData } from '../../static/staticData'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { FooterComp, LayoutType1, LayoutType2 } from './boxlayouts'
import { styles } from './styles'

const JioBizz = () => {
  const [navVisible, setNavVisible] = useState(false)
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }
  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  const resPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const isDesktop = width > 1025
  const { headerSize, textSize, headerLineHeight, textLineHeight } = useFontSize()
  const themedStyle = styles(width, resPadding)

  const jioMarketingImage = require('../../assets/images/jiobizz/marketing-page/jiobizz-marketing-new.png')

  return (
    <Box f={1}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Box {...themedStyle.boxOverview} />
      <Navbar onPress={handleNav} isLightBackground={true} hideRightMenu={false} />
      <Box {...themedStyle.topContainer}>
        <Box h={1} bg={'#0000001F' as ColorOptions} />
        <Box {...themedStyle.container}>
          <Box {...themedStyle.imageContainer}>
            <Image
              source={jioMarketingImage}
              width={isMobile ? '100%' : isTab ? 550 : width / 2 + resPadding / 2}
              height={isMobile ? 260 : isTab ? 550 : 580}
              resizeMode={'contain'}
            />
          </Box>
          <Box {...themedStyle.textContainer}>
            <Spacer direction={'vertical'} size={isMobile || isTab ? 0 : 120} />
            <Box {...themedStyle.rowContainer}>
              <Box top={-2}>
                <Mobile width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} />
              </Box>
              <Spacer size={16} direction={'horizontal'} />
              <Text
                fontFamily="jiotype-medium"
                fontSize={isMobile ? 12 : 18}
                color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
                letterSpacing={3.6}
                lineHeight={isMobile ? 16 : isTab ? 18 : 32}>
                {'JIOPAY BUSINESS APP'}
              </Text>
              <Spacer direction="horizontal" size={16} />
              <Box h={'1'} bg={colors.JIO_PRIMARY_ALPHA as ColorOptions} w={48} />
            </Box>
            <Spacer size={isTab || isMobile ? 24 : 16} direction={'vertical'} />
            <Text
              title={staticStrings.simpleInstantUpi}
              color={'BRAND_PRIMARY_BLACK'}
              fontFamily={'jiotype-black'}
              fontSize={headerSize}
              lineHeight={headerLineHeight}
              textAlign={isTab ? 'center' : 'left'}
            />
            <Spacer size={isMobile ? 16 : isTab ? 24 : 20} direction={'vertical'} />
            <Text
              title={staticStrings.jiobizzLabel}
              color={'PRIMARY_GREY'}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              lineHeight={textLineHeight}
              textAlign={isTab ? 'center' : 'left'}
            />
            <Spacer size={isMobile ? 24 : 40} direction={'vertical'} />
            <Box onPress={openPlayStore} underlayColor="TRANSPARENT">
              <Image
                source={require('../../assets/images/google-play.png')}
                width={isMobile ? 108 : 162}
                height={isMobile ? 32 : 48}
                resizeMode={'contain'}
              />
            </Box>
          </Box>
        </Box>
        <Spacer direction={'vertical'} size={isMobile || isTab ? 64 : 170} />
        <Box {...themedStyle.bgRound}>
          <Box {...themedStyle.bgRadius} />
          <Spacer direction={'vertical'} size={24} />
        </Box>
        <LayoutType1 data={jiobizzUpiData} />
        <Box {...themedStyle.bgRound} backgroundColor={'WHITE'}>
          <Box {...themedStyle.bgRadius} backgroundColor={colors.HOVER_BG as ColorOptions} />
          <Spacer direction={'vertical'} size={24} />
        </Box>
        <LayoutType2 />
        <Spacer direction={'vertical'} size={isDesktop ? 120 : 40} />
        <Box {...themedStyle.bgRound}>
          <Box {...themedStyle.bgRadius} backgroundColor={colors.JIO_PRIMARY_ALPHA as ColorOptions} />
          <Spacer direction={'vertical'} size={24} />
        </Box>
        <FooterComp />
        <Box bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}>
          <Box
            bg={'WHITE'}
            marginTop={isMobile ? 40 : undefined}
            pt={isMobile ? 60 : undefined}
            borderTopLeftRadius={isMobile ? 32 : 120}
            borderTopRightRadius={isMobile ? 32 : 120}>
            <Footer />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { JioBizz as default }
